import React, { useContext, useState } from 'react'
import { EasybakeContext } from '../EasybakeProvider'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import analytics from '../../config/analytics'
import { copyText, getPlatform } from '../../lib/easybake'

import Button from '@react/react-spectrum/Button'
import Heading from '@react/react-spectrum/Heading'
import Checkmark from '@react/react-spectrum/Icon/Checkmark'
import Copy from '@react/react-spectrum/Icon/Copy'
import Well from '@react/react-spectrum/Well'
import CodeSnippetCurl from './CodeSnippetCurl'

export default function WizardAccessToken () {
    const { ut, page, cred } = useContext(EasybakeContext)
    const [copyStateCurlCommand, setCopyStateCurlCommand] = useState(false)

    function copyActionCurlCommand(e, target) {
        analytics.sendEventName('click', `${page}:copyCurlCommand`)
        copyText(target, page)
        setCopyStateCurlCommand(true)
        setTimeout(() => setCopyStateCurlCommand(false), 600);
    }

    function getCurlCommand(e) {
        let curlCommand = `curl --request POST --url "${process.env.REACT_APP_CONFIG_APP_IMS_API_ENDPOINT}/ims/token/v3" --header "Content-Type: application/x-www-form-urlencoded" --data "grant_type=client_credentials&client_id=${cred && cred.apiKey}&client_secret=${cred && cred.clientSecret.client_secret}&scope=${process.env.REACT_APP_CONFIG_APP_SP_SCOPE}"`
        if (getPlatform() === 'mac') {
            curlCommand = `curl --request POST \\\n  --url "${process.env.REACT_APP_CONFIG_APP_IMS_API_ENDPOINT}/ims/token/v3" \\\n  --header "Content-Type: application/x-www-form-urlencoded" \\\n  --data "grant_type=client_credentials&client_id=${cred && cred.apiKey}&client_secret=${cred && cred.clientSecret.client_secret}&scope=${process.env.REACT_APP_CONFIG_APP_SP_SCOPE}"`
        }
        return curlCommand
    }

    return (
        <div className="adobe-easybake-main-wizard">
            <div className="adobe-easybake-flex-row"><Heading variant="subtitle1">{__('console_credinfo_generate_token_title')}</Heading></div>
            <div className="adobe-easybake-p-cred">{__('console_credinfo_generate_token_desc')}</div>
            <br />
            <Well>
                <div className='adobe-easybake-sp-access-token-title'>
                    <div className='adobe-easybake-sp-access-token-subtitle'>{__("signup_wizard_curl_title_token")}</div>
                    <div className="adobe-easybake-credinfo-button">
                        { copyStateCurlCommand ? <Button
                            style={{
                            alignItems: 'center',
                            backgroundColor: '#12805C',
                            padding: '0px 36px'
                            }}
                            icon={<Checkmark style={{color: '#ffffff'}} />}
                            variant="action"
                        /> : <Button variant="action"
                            icon={<Copy />}
                            onClick={ e => copyActionCurlCommand(e, getCurlCommand()) }>{__('console_credinfo_btn_copy')}
                        </Button>}
                    </div>
                </div>
                <div className="adobe-easybake-code-preview-curl">
                    <CodeSnippetCurl language="json" text={getCurlCommand()}/>
                </div>
            </Well>
        </div>
    )
}
